export const APP_LOCALE = 'es-MX'
export const APP_CURRENCY = 'MXN'
